import { SvgIcon } from "@material-ui/core";

export const ArrowRight = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      transform="translate(2 3)"
      d="M6.862.529c.26-.26.682-.26.943 0l4 4 .014.014.036.042c.011.014.021.027.03.042.013.018.025.037.036.057l.01.02c.012.024.022.048.03.073l.01.026.01.04c.024.099.025.201.004.3-.012.052-.03.102-.052.15l-.019.034c-.009.016-.018.032-.028.046-.024.035-.05.068-.081.098l.053-.06c-.013.016-.026.032-.04.046l-.013.014-4 4c-.26.26-.683.26-.943 0-.26-.26-.26-.682 0-.942l2.861-2.863H.667c-.335 0-.612-.246-.66-.567L0 5c0-.368.298-.667.667-.667h9.056L6.862 1.47c-.234-.234-.258-.6-.07-.86z"
    />
  </SvgIcon>
);